import { CategoriesState } from './types';

export const initialState: CategoriesState = {
  categories: null,
  loadingCategories: false,
  allProjectCategoriesForChannel: null,
  loadingAllProjectCategoriesForChannel: false,
};
